export interface KnowledgeSyncLabels {
  processing: string;
  enriching: string;
  embedding: string;
  ready: string;
  failed: string;
  idle: string;
  // Looked up dynamically by status string (see sync-status statusLabel getter).
  [status: string]: string;
}

export interface KnowledgeSyncConfig {
  convID: string;
  status: string;
  lastSyncAt: string;
  labels: KnowledgeSyncLabels;
}

export function knowledgeSyncStatus(config: KnowledgeSyncConfig) {
  return {
    status: config.status,
    lastSyncAt: config.lastSyncAt,
    isStale: false, // conversations don't have a stale concept
    _labels: config.labels,

    get statusLabel(): string {
      return this._labels[this.status] ?? this._labels.idle;
    },

    get isProcessing(): boolean {
      return (
        this.status === "processing" || this.status === "enriching" || this.status === "embedding"
      );
    },

    get isReady(): boolean {
      return this.status === "ready";
    },

    get isFailed(): boolean {
      return this.status === "failed";
    },

    /** Alias for backward compatibility and knowledgeSyncInnerButton compatibility. */
    get tooltipLabel(): string {
      if (this.lastSyncAt) {
        return `${this.statusLabel} (${this.lastSyncAt})`;
      }
      return this.statusLabel;
    },

    /** @deprecated Use tooltipLabel instead */
    get tooltipText(): string {
      return this.tooltipLabel;
    },

    /** Called by @htmx:after-request on the button — optimistically mark as processing. */
    onSyncResponse(event: Event) {
      const htmxEvent = event as CustomEvent;
      if (!htmxEvent.detail.successful) return;
      this.status = "processing";
    },

    init() {
      window.addEventListener("knowledge_sync_status", (e: Event) => {
        const ce = e as CustomEvent;
        const data = JSON.parse(ce.detail.data);
        if (data.conversation_id === config.convID) {
          this.status = data.status;
          if (data.last_sync_at) this.lastSyncAt = data.last_sync_at;
        }
      });
    },
  };
}
